import { OptOut } from "commonAssets/components/Forms/OptOut";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import { createElement } from "commonAssets/lib/createElement";

export class customOptOut extends OptOut {
    exclusion_form(params) {
        const exclusionContactInfo =
            params.form_options?.exclusion_form?.contact_information;
        if (exclusionContactInfo) {
            params.form_options.claim_form.contact_information =
                exclusionContactInfo;
        }
        const form = super.exclusion_form(params);
        this.injectNoticeIdField(form);
        return form;
    }

    injectNoticeIdField(form) {
        const phoneField = form.querySelector("#phone_number_1");
        if (!phoneField) return;
        const wrapper = phoneField.closest(".divContactField");
        if (!wrapper) return;
        const noticeIdWrapper = createElement(
            "div",
            {
                class: "col mb-3 divContactField",
                id: "divContactField_zero_zero_id",
            },
            [
                createElement(
                    "label",
                    { for: "zero_zero_id" },
                    [],
                    'Notice ID (if known) <span class="error"></span>'
                ),
                createElement("input", {
                    type: "text",
                    class: "form-control",
                    id: "zero_zero_id",
                    name: "zero_zero_id",
                    "data-contact-label": "Notice ID (if known)",
                }),
            ]
        );
        wrapper.insertAdjacentElement("afterend", noticeIdWrapper);
    }

    init_exclusion_fields(...args) {
        super.init_exclusion_fields(...args);
        this.exclusion.inputs.fields = Array.from(
            document.querySelectorAll("#zero_zero_id")
        );
    }

    process_exclusion(e, exclusion, deadline) {
        const noticeIdInput = document.getElementById("zero_zero_id");
        if (noticeIdInput) {
            exclusion.data.zero_zero_id = noticeIdInput.value;
        }
        super.process_exclusion(e, exclusion, deadline);
        if (noticeIdInput && Array.isArray(exclusion.inputs)) {
            exclusion.inputs.push(noticeIdInput);
        }
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        i18n,
        enableClaimFields = false,
        enableClaimTransactions = false,
        errorHandler = new ErrorHandler(),
    }) {
        return new this(
            appClaimForm,
            userLanguage,
            i18n,
            enableClaimFields,
            enableClaimTransactions,
            errorHandler
        );
    }
}
